// frontend/src/authSlice.js

import { createSlice } from '@reduxjs/toolkit';

// This slice will manage the authentication state across the entire application.
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    // CRITICAL FIX: Load the token from localStorage on initial app load.
    // This is what keeps the user logged in after a page refresh.
    accessToken: localStorage.getItem('accessToken') || null,
    // We can add more user-related info here later, e.g., username, id.
    user: null,
    preferredCurrency: localStorage.getItem('preferredCurrency') || 'EUR',
    theme: localStorage.getItem('theme') || 'system',
    viewMode: localStorage.getItem('viewMode') || 'auto', // 'auto', 'mobile', or 'desktop'
  },
  reducers: {
    /**
     * Handles a successful login event.
     * @param {object} state - The current Redux state.
     * @param {object} action - The action dispatched, containing the payload.
     */
    loginSuccess(state, action) {
      const { accessToken, user } = action.payload;
      state.accessToken = accessToken;
      state.user = user;

      // CRITICAL FIX: Save the token to localStorage so it persists across sessions.
      localStorage.setItem('accessToken', accessToken);
    },

    /**
     * Handles a logout event.
     * @param {object} state - The current Redux state.
     */
    logout(state) {
      state.accessToken = null;
      state.user = null;

      // Clear localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('preferredCurrency');
      localStorage.removeItem('theme');
      state.preferredCurrency = 'EUR';
      state.theme = 'system';

      // Clear httpOnly cookies via backend
      fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }).catch(() => { });
    },

    setPreferredCurrency(state, action) {
      const currency = action.payload;
      state.preferredCurrency = currency;
      localStorage.setItem('preferredCurrency', currency);
    },

    setTheme(state, action) {
      const theme = action.payload;
      state.theme = theme;
      localStorage.setItem('theme', theme);
    },

    setViewMode(state, action) {
      state.viewMode = action.payload;
      localStorage.setItem('viewMode', action.payload);
    },
  }
});

// Export the actions so they can be "dispatched" from anywhere in the app.
export const { loginSuccess, logout, setPreferredCurrency, setTheme, setViewMode } = authSlice.actions;

// Export the reducer to be included in the main Redux store.
export default authSlice.reducer;